
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dextjkwaakemawccilpd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRleHRqa3dhYWtlbWF3Y2NpbHBkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIyNzIxMzMsImV4cCI6MjA1Nzg0ODEzM30.Pmz91BupapePAg6DQ97tTPdt5JPEUtBWSYDv5W9BcQE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
